<template>
  <div v-show="tableType == 1">
    <el-table @filter-change="filterChange" @sort-change="handleSortChange" :data="showdata.slice((currentPage-1)*pageSize,currentPage*pageSize)" :cell-style="setStyle1" :max-height="tableHeight">
      <el-table-column
        label="人员"
        prop="fuUser"
        key="1"
        column-key="fuUser"
        :filters="userAll"
        :filter-method="filterHandler1"
      >
        <template slot-scope="{ row }">
          <div>{{ "主要人员:" + row.fuUser }}</div>
          <br />
          <div>{{ "辅助人员:" + row.user }}</div>
        </template>
      </el-table-column>
      <el-table-column label="楼盘数据" key="2">
        <el-table-column
          label="城区"
          prop="district"
          key="3"
          column-key="district"
          :filters="districts"
          :filter-method="filterHandler1"
        >
        </el-table-column>
        <el-table-column :label="computetotal" column-key="real_estate_name" prop="real_estate_name" key="4">
        
        </el-table-column>
        <el-table-column
          label="楼盘月浏览量"
          prop="person_page"
          column-key="person_page"
          sortable="custom"
          key="24"
        >
          <template slot-scope="{ row }">
            <div>{{ (row.area_rank && row.area_rank.thirtyHits) || 0 }}</div>
          </template>
        </el-table-column>

        <el-table-column
          label="销售状态"
          :filters="[
            { text: '在售', value: '在售' },
            { text: '待首开', value: '待首开' }
          ]"
          :filter-method="filterHandler1"
          prop="real_status"
          key="5"
          column-key="real_status"
        >
        </el-table-column>
      </el-table-column>
      <el-table-column label="综合数据" key="6">
        <el-table-column
          label="综合完整度"
          :filters="[
            { text: '达标', value: '达标' },
            { text: '不达标', value: '不达标' }
          ]"
          :filter-method="filterHandler111"
          prop="all_tagecg"
          key="7"
          column-key="all_tagecg"
          sortable="custom"
        >
        </el-table-column>
      </el-table-column>
      <el-table-column label="户型相关" key="9">
        <el-table-column
          label="户型尺寸"
          :filters="[{ text: '有', value: '有' }, { text: '无', value: '无' }]"
          prop="hx"
          :filter-method="filterHandler11"
          column-key="hx"
          key="10"
        >
          <!-- :column-key="'hx'" -->
        </el-table-column>
        <!--
          <template slot="header" slot-scope="{ column }">
              <span>{{ column.label }}<i class="co-icon-filter"/></span>
          </template>
        -->
        <el-table-column
          label="精装配置"
          v-if="city == '杭州'"
          :filters="[{ text: '有', value: '有' }, { text: '无', value: '无' }]"
          :filter-method="filterHandler11"
          prop="tabel"
          key="12"
          column-key="tabel"

        >
        </el-table-column>
      </el-table-column>
      <el-table-column label="楼盘动态" key="13">
        <el-table-column label="预计开盘" prop="expect" key="14"
          :filters="expectFilters"
          :filter-method="expectFilterHandler"
          column-key="expect"
        >
          <template slot-scope="{ row }">
            <div>{{ (row.expect && row.expect.date) || row.xs }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="销售动态"
          :filters="[{ text: '有', value: '有' }, { text: '无', value: '无' }]"
          :filter-method="filterHandler11"
          prop="dynamic"
          key="16"
          column-key="dynamic"
        >
        </el-table-column>
        <el-table-column
          label="优惠动态"
          v-if="city == '杭州'"
          prop="youhui"
          key="17"
          :filters="[{ text: '有', value: '有' }, { text: '无', value: '无' }]"
          :filter-method="filterHandler11"
          column-key="youhui"

        >
        </el-table-column>
      </el-table-column>
      <el-table-column label="常规" key="19">
        <el-table-column
          label="详细完成度"
          prop="details_tage"
          key="20"
          :filters="[
            { text: '达标', value: '达标' },
            { text: '不达标', value: '不达标' }
          ]"
          :filter-method="filterHandler111"
          column-key="details_tage"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column label="图片" sortable="custom" prop="estate" key="21"
        :filters="[
            { text: '已完成', value: '已完成' },
            { text: '未完成', value: '未完成' }
          ]"
        column-key="estate">
        </el-table-column>
        <el-table-column label="视频" sortable="custom" prop="video" column-key="video" 
        :filters="[
            { text: '已完成', value: '已完成' },
            { text: '未完成', value: '未完成' }
          ]" key="22">
        </el-table-column>
      </el-table-column>
      <el-table-column label="积分" key="23"> </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="showdata.length">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "SjAndYuny",
  props: [
    "person",
    "finishCount",
    "build_type",
    "tableType",
    "tableHeight",
    "districts",
    "userAll",
    "city"
  ],
  data() {
    
    return {
      style1sus: "background-color: #C7FFA2",
      style1fat: "background-color: #FFA2A2",
      expectFilters: [],
      currentPage: 1,
      pageSize: 10,
      tabledata:[],
      showdata:[],
      chosedfilter:[],
    };
  },

  watch: {
    person(newVal) {
      console.log('newVal',newVal);
      this.tabledata = newVal
      this.showdata = this.tabledata
      let emap = {};
      newVal.forEach(x => {
        if (x.expect && x.expect.date) {
          emap[x.expect.date] = 1;
        }
      })
      let filters = [];
      for (let key in emap) {
        filters.push({
          text: key,
          value: key
        })
      }
      filters.sort((a,b) => {
        return a.value.localeCompare(b.value);
      })
      this.expectFilters = filters;
    },
  },
  created(){
    this.init()
  },
  methods: {
    init(){
      this.tabledata=this.person;
    },
    setStyle1({ row, column, rowIndex, columnIndex }) {
      const property = column["property"];
      if(this.city=='杭州'){
        if (columnIndex == 5) {
        if (row[property].split("%")[0] * 1 > 85) {
          return this.style1sus;
        }
      } else if (columnIndex == 6) {
        if (row[property] !== "无") {
          if (row[property].split("个")[0] * 1 >= 1) {
            return this.style1sus;
          }
        }
      } else if (columnIndex == 7) {
        if (row[property] !== "无") {
          return this.style1sus;
        }
      } else if (columnIndex == 9) {
        if (row[property] !== "无") {
          return this.style1sus;
        }
      } else if (columnIndex == 10) {
        if (
          row[property] !== "无" ||
          (row["district"] !== "富阳区" && row["district"] !== "临安区")
        ) {
          return this.style1sus;
        }
      } else if (columnIndex == 11) {
          if (
            this.build_type == "住宅" &&
            row[property].split("%")[0] * 1 >= 85
          ) {
            return this.style1sus;
          } else if (
            this.build_type == "公寓" &&
            row[property].split("%")[0] * 1 >= 80
          ) {
            return this.style1sus;
          }
      } else if (columnIndex == 12) {
          if (row[property] !== 0) {
            if (
              this.build_type == "住宅" &&
              row[property].split("个")[0] * 1 >= 40
            ) {
              return this.style1sus;
            } else if (
              this.build_type == "公寓" &&
              row[property].split("个")[0] * 1 >= 15
            ) {
              return this.style1sus;
            }
          }
      } else if (columnIndex == 13) {
          if (row[property] !== 0) {
            if (
              this.build_type == "住宅" &&
              row[property].split("个")[0] * 1 >= 5 &&
              row[property].includes('沙盘') && 
              row[property].includes('区位')
            ) {
              return this.style1sus;
            } else if (
              this.build_type == "公寓" &&
              row[property].split("个")[0] * 1 >= 1
            ) {
              return this.style1sus;
            }
          }
      }
      if (columnIndex > 4 && columnIndex !== 8 && columnIndex !== 14)
        return this.style1fat;
      }else{
        if (columnIndex == 5) {
        if (row[property].split("%")[0] * 1 > 85) {
          return this.style1sus;
        }
      } else if (columnIndex == 6) {
        if (row[property] !== "无") {
          if (row[property].split("个")[0] * 1 >= 1) {
            return this.style1sus;
          }
        }
      } else if (columnIndex == 8) {
        if (row[property] !== "无") {
          return this.style1sus;
        }
      }else if (columnIndex == 9) {
          if (
            
            row[property].split("%")[0] * 1 >= 70
          ) {
            return this.style1sus;
          } 
      } else if (columnIndex == 10) {
          if (row[property] !== 0) {
            if (
              this.build_type == "住宅" &&
              row[property].split("个")[0] * 1 >= 20
            ) {
              return this.style1sus;
            } else if (
              this.build_type == "公寓" &&
              row[property].split("个")[0] * 1 >= 20
            ) {
              return this.style1sus;
            }
          }
      } else if (columnIndex == 11) {
          if (row[property] !== 0) {
            if (
              this.build_type == "住宅" &&
              row[property].split("个")[0] * 1 >= 1
            ) {
              return this.style1sus;
            } else if (
              this.build_type == "公寓" &&
              row[property].split("个")[0] * 1 >= 1
            ) {
              return this.style1sus;
            }
          }
      }
      if (columnIndex > 4 && columnIndex !== 7&& columnIndex !== 12 )
        return this.style1fat;
      }
      
    },
    handleSortChange({ column, prop, order }){
      if(prop=='person_page'){//月浏览量
        this.showdata.sort((a, b) => {
          if (order === 'ascending') {
            return a['area_rank']['thirtyHits'] > b['area_rank']['thirtyHits'] ? 1 : -1;
          } else if (order === 'descending') {
            return a['area_rank']['thirtyHits'] < b['area_rank']['thirtyHits'] ? 1 : -1;
          }
          return 0;
        });
      }else if(prop=='estate'||prop=='video'){
        // if(prop=='all_tagecg' || prop=='details_tage')
        this.showdata.sort((a, b) => {
          if (order === 'ascending') {
            if(a[prop]!=0){
              if(b[prop]!=0){
                return Number(a[prop].split("个")[0])> Number(b[prop].split("个")[0]) ? 1 : -1;
              }else return Number(a[prop].split("个")[0])> b[prop] ? 1 : -1;
            }else if(b[prop]!=0){
              return a[prop]> Number(b[prop].split("个")[0]) ? 1 : -1;
            }
            else return a[prop] > b[prop] ? 1 : -1;
          } else if (order === 'descending') {
            if(a[prop]!=0){
              if(b[prop]!=0){
                return Number(a[prop].split("个")[0])< Number(b[prop].split("个")[0]) ? 1 : -1;
              }else return Number(a[prop].split("个")[0])< b[prop] ? 1 : -1;
            }else if(b[prop]!=0){
              return a[prop]< Number(b[prop].split("个")[0]) ? 1 : -1;
            }
            else return a[prop] < b[prop] ? 1 : -1;
          }
          return 0;
        });
      }
      else{//综合完整度 详细完整度
        // if(prop=='all_tagecg' || prop=='details_tage')
        this.showdata.sort((a, b) => {
          if (order === 'ascending') {
            return Number(a[prop].split("%")[0]) >  Number(b[prop].split("%")[0]) ? 1 : -1;
          } else if (order === 'descending') {
            return Number(a[prop].split("%")[0]) < Number(b[prop].split("%")[0]) ? 1 : -1;
          }
          return 0;
        });
      }
    },
    
    filterHandler1(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    filterHandler111(value, row, column) {
      const property = column["property"];
      console.log(this.tableType);
      if (this.build_type == "住宅") {
        if (value == "达标") {
          if (row[property].split("%")[0] * 1 > 85) {
            return true;
          }
        } else if (value == "不达标") {
          if (row[property].split("%")[0] * 1 < 85) {
            return true;
          }
        }
      } else if (this.build_type == "公寓") {
        if (value == "达标") {
          if (row[property].split("%")[0] * 1 > 80) {
            return true;
          }
        } else if (value == "不达标") {
          if (row[property].split("%")[0] * 1 < 80) {
            return true;
          }
        }
      }
    },
    filterHandler11(value, row, column) {
      const property = column["property"];
      if (value == "无") {
        return row[property] === value;
      } else {
        return row[property] !== "无";
      }
    },
    filterChange(filters) {
      this.showdata = this.tabledata
      console.log('filters',Object.keys(filters));
      let key = Object.keys(filters)//改的列的prop
      console.log('filters[key]',filters[key]);//改的列的筛选值
      console.log('filters[key].length',filters[key].length);
      let haschosed = false//假设未筛选过该列
        for(let k = 0;k<this.chosedfilter.length;k++){
          let kkey = Object.keys(this.chosedfilter[k])
          if(kkey[0] == key[0]){
            this.chosedfilter[k] = filters;
            haschosed=true;
            break
          }
        }
        if(!haschosed && filters[key].length){
          this.chosedfilter.push(filters)
        }
        this.chosedfilter.filter(item=>{
          return item != key
        })
        console.log('this.chosedfilter',this.chosedfilter);
        this.chosedfilter.forEach(item=>{
          let ckey = Object.keys(item)
          this.filterfunc(ckey,item[ckey])
        })
        this.currentPage = 1
    },
    // filterChange(filters) {
    //   console.log('filters',Object.keys(filters));
    //   let key = Object.keys(filters)
    //   console.log('filters[key]',filters[key]);
    //   if(filters[key].length==0){//重置
    //     this.showdata = this.tabledata
    //     this.chosedfilter.filter(item=>{
    //       return item != key
    //     })
    //     console.log('this.chosedfilter',this.chosedfilter);
    //     for(let k = 0;k<this.chosedfilter.length;k++){
    //       let ckey = Object.keys(this.chosedfilter[k])
    //       this.filterfunc(ckey,this.chosedfilter[ckey])
    //     }

    //   }else{
    //     let haschosed = false
    //     for(let k = 0;k<this.chosedfilter.length;k++){
    //       if(Object.keys(this.chosedfilter[k])==key){
    //         this.chosedfilter[k] = filters
    //         haschosed=true
    //         break
    //       }
    //     }
    //     if(!haschosed){
    //       this.chosedfilter.push(filters)
    //     }
    //     this.filterfunc(key,filters[key])
    //   }
    // },
    filterfunc(key,filter){
      if(filter.length==0) return
      if(key=='hx'||key=='tabel'||key=='dynamic'||key=='youhui'){
          this.showdata = this.showdata.filter((item)=>{
          for(let i = 0;i < filter.length;i++){
            // console.log('item[key]',item[key]);
            // console.log('filters[key][i]',filter[i]);
            if(filter[i]=='无'){
              return item[key] === filter[i];
              break
            }else{
              return item[key] != '无'
              break
            }
          }
        })
        }else if(key=='estate'){
          this.showdata = this.showdata.filter((item)=>{
          for(let i = 0;i < filter.length;i++){
            if (this.build_type == "住宅") {
              if (filter[i] == "已完成") {
                if(item[key]==0){
                  return false
                }else if (Number(item[key].split("个")[0]) >= 40) {
                  return true;
                  break
                }
              } else if (filter[i] == "未完成") {
                if(item[key]==0){
                  return true
                }else if (Number(item[key].split("个")[0])< 40) {
                  return true;
                  break
                }
              }
            } else if (this.build_type == "公寓") {
              if (filter[i] == "已完成") {
                if(item[key]==0){
                  return false
                }else if (Number(item[key].split("个")[0]) >= 15) {
                  return true;
                  break
                }
              } else if (item[key] == "未完成") {
                if(item[key]==0){
                  return true
                }else if (Number(item[key].split("个")[0]) < 15) {
                  return true;
                  break
                }
              }
            }
          }
        })
        }else if(key=='video'){
          this.showdata = this.showdata.filter((item)=>{
            for(let i = 0;i < filter.length;i++){
            if (this.build_type == "住宅") {
              if (filter[i] == "已完成") {
                if(item[key]==0){
                  return false
                }else if (Number(item[key].split("个")[0]) >= 5 && item[key].includes('沙盘') && item[key].includes('区位')) {
                  return true;
                  break
                }
              } else if (filter[i] == "未完成") {
                if(item[key]==0){
                  return true
                }else if (!(Number(item[key].split("个")[0]) >= 5 && item[key].includes('沙盘') && item[key].includes('区位'))) {
                  return true;
                  break
                }
              }
            } else if (this.build_type == "公寓") {
              if (filter[i] == "已完成") {
                if(item[key]==0){
                  return false
                }else if (Number(item[key].split("个")[0]) >= 1) {
                  return true;
                  break
                }
              } else if (filter[i] == "未完成") {
                if(item[key]==0){
                  return true
                }else if (Number(item[key].split("个")[0]) < 1) {
                  return true;
                  break
                }
              }
            }
          }
        })
        }else if(key=='details_tage'||key=='all_tagecg'){
          this.showdata = this.showdata.filter((item)=>{
          for(let i = 0;i < filter.length;i++){
            if (this.build_type == "住宅") {
              if (filter[i] == "达标") {
                if (Number(item[key].split("%")[0]) > 85) {
                  return true;
                  break
                }
              } else if (filter[i] == "不达标") {
                if (Number(item[key].split("%")[0])< 85) {
                  return true;
                  break
                }
              }
            } else if (this.build_type == "公寓") {
              if (filter[i] == "达标") {
                if (Number(item[key].split("%")[0]) > 80) {
                  return true;
                  break
                }
              } else if (item[key] == "不达标") {
                if (Number(item[key].split("%")[0]) < 80) {
                  return true;
                  break
                }
              }
            }
          }
        })
        }else if(key=='expect'){
          console.log('预计开盘filter',filter);
          this.showdata = this.showdata.filter((item)=>{
            let flag = false
            for(let i = 0;i < filter.length;i++){
              if(item.expect && item.expect.date == filter[i]){
                flag=true
                break
              }
            }
            return flag
        })
        }
        else{
          this.showdata = this.showdata.filter((item)=>{
          for(let i = 0;i < filter.length;i++){
            if(item[key]===filter[i]){
              return true;
              break
            }
          }
        })
        }
      },
    
    // handleFilterChange(value){
    // console.log('表格筛选',value);
    //   if(!this.filterValue){
    //     this.tabledata=this.person
    //   }
    //   this.tabledata=this.person.filter((row)=>row[this.filterKey]===this.filterValue)
    // },
    // handleFilterChange(filters) {
    //     console.log(filters)
    //     if(filters.hasOwnProperty('filteredData4'))
    //     {

    //     }
    //     else if(filters.hasOwnProperty('filteredData5'))
    //     {
    //       if(filters.filteredData5.length===0||filters.filteredData5.length===2)
    //       {
    //         this.person = this.persondata
    //       }else{
    //         if (filters.filteredData5[0]== "完成") {
    //           let h=this.person
    //           h=this.persondata.filter(item=>item.estate.length>=2)
    //           this.person=h.filter(item=>item.estate.split("个")[0] * 1 >= 40)
    //     } 
    //     if (filters.filteredData5[0]== "未完成") {
      
    //       let h=this.person
    //           this.person=this.persondata.filter(item=>item.estate.length===undefined||item.estate.split("个")[0] * 1 <40)
    //     }
    //       }
    //     }
    //     this.$emit('update',this.person)
    //   // 自定义筛选逻辑
    //   // 可以根据 `filters` 对象中的条件来更新 `tableData`
    // },
    expectFilterHandler(value, row, column) {
      return row.expect && row.expect.date == value;
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.currentPage = 1; // 重置当前页为第一页
    },
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
    }
  },
  computed:
  {
    computetotal:
    {
      get()
      {
        return `楼盘总数(${this.showdata.length})`
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sjandyuny.vue